import { useLocalStore } from 'mobx-react-lite';

import Entities from 'STORE';

interface IPrivateDomainPresenter {
  isAllowedPrivateContent: boolean;
  isShowSkeleton: boolean;
}

export function usePrivateDomainPresenter(): IPrivateDomainPresenter {
  const presenter = useLocalStore<IPrivateDomainPresenter>(() => ({
    get isAllowedPrivateContent(): boolean {
      const { isAuthenticated, isGuestCallSession } = Entities.authStore;
      return isAuthenticated && !isGuestCallSession;
    },

    get isShowSkeleton(): boolean {
      return !Entities.authStore.isFirstAuthDone;
    },
  }));

  return presenter;
}
